import { useState, useEffect, useCallback } from "react";
import { Box, Typography, Divider, RadioGroup, Button, Grid, IconButton } from "@mui/material";
import { useQuery, useQueries, useIsFetching } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineTrash } from "react-icons/hi";
import { BASE_INFOS_API, DEMANDS_INFORMATION_API, FILTER_API } from "../../api";
import {
  setDemandsInformationData,
  updateArrayFieldDemandsInformationData,
  updateDemandsInformationData,
  addNewOtherDemand,
  removeFromOtherDemand,
  updateOtherDemand,
  setReloadDemandsInformationData,
} from "../../slice";
import { useDemandsInfo } from "../../hooks";
import Input from "../Input";
import Select from "../Select";
import AddField from "./AddField";
import RangeSlider from "../all-inputs/BaseSlider";
import BaseRadio from "../all-inputs/BaseRadio";
import BaseCheckbox from "../all-inputs/BaseCheckbox";
import BaseSwitch from "../all-inputs/BaseSwitch";
import BaseTextArea from "../all-inputs/BaseTextArea";
import { BaseRadioGroup } from "../inputs/RadioGroup";
import AutoComplete from "../inputs/AutoComplete";

function Requests({ hasEditAccess, onError = () => {}, disabled = false, pageErrors = {} }) {
  const dispatch = useDispatch();
  const { data, reloadPage } = useSelector((state) => state.DemandsInformation);
  const { userInfo } = useSelector((state) => state.UserCurrentState);
  const [errors, setErrors] = useState({});
  const [isSpouseEthnicity, setIsSpouseEthnicity] = useState(false);
  const [enabledPriority, setEnabledPriority] = useState("");
  const [isNotMatterPriorityId, setIsNotMatterPriorityId] = useState();
  const [showCheckBoxError, setShowCheckBoxError] = useState({
    educationLevelAllowedTitles: true,
    educationGroupAllowedTitles: true,
    maritalStatus: true,
  });
  const isFetching = useIsFetching();
  const { handleSubmit: handleSubmitForm } = useDemandsInfo({ hasEditAccess, errors });

  const handleIsContactMe = (event) => {
    if (event.target.value) {
      [
        "trustedFirstName",
        "trustedLastName",
        "trustedRelation1",
        "trustedLandNumber",
        "trustedMobileNumber",
      ].forEach((key) => {
        dispatch(
          updateDemandsInformationData({
            key,
            value: "",
            required: true,
          })
        );
      });
    }
  };

  const handlelivingCityPriority = (livingCityPriority, event) => {
    ["livingCityPriorityOneId", "livingCityPriorityTwoId", "livingCityPriorityThreeId"].forEach(
      (key) => {
        if (key !== livingCityPriority) {
          if (parseInt(event.target.value) === isNotMatterPriorityId) {
            setEnabledPriority(livingCityPriority);
            dispatch(
              updateDemandsInformationData({
                key,
                value: "",
                required: true,
              })
            );
          } else {
            setEnabledPriority("");
          }
        } else {
          dispatch(
            updateDemandsInformationData({
              key,
              value: event.target.value,
              required: true,
            })
          );
        }
      }
    );
  };

  const handleHaveChildrenAllowed = (event) => {
    dispatch(
      updateDemandsInformationData({
        key: "haveChildrenAllowed",
        value: event.target.checked,
        required: true,
      })
    );
    ["childGenderMatter", "childrenCountMatter", "childrenAgeMatter"].forEach((key) => {
      dispatch(
        updateDemandsInformationData({
          key,
          value: false,
          required: true,
        })
      );
    });
  };

  const { refetch: getDemandsInformation } = useQuery(
    ["getDemandsInformation"],
    () => DEMANDS_INFORMATION_API.GetDemandsInformation(),
    {
      onSuccess: ({ data: DemandsInformation }) => {
        if (DemandsInformation.success && DemandsInformation.data) {
          setIsSpouseEthnicity(DemandsInformation.data.spouseEthnicityMatter);
          dispatch(setDemandsInformationData(DemandsInformation.data));
          handleGetisNotMatterPriorityId(DemandsInformation.data);
        }
        dispatch(setReloadDemandsInformationData(false));
      },
      staleTime: Infinity,
    }
  );

  const { data: lookupsData } = useQuery(
    ["getFilterDataCollection_requests"],
    () =>
      FILTER_API.GetFilterDataCollection(
        true,
        [28000, 33000, 42000, 5000, 37000, 13000, 11000, 25000, 26000, 8000, 27000]
      ),
    {
      staleTime: Infinity,
    }
  );

  //todo: in be useQuery bayad tabdil beshe
  const [residencePriorities] = useQueries({
    queries: [
      {
        queryKey: ["getResidencePrioritiesByCountryId", 1],
        queryFn: BASE_INFOS_API.GetResidencePrioritiesByCountryId.bind(null, 1),
        staleTime: Infinity,
      },
    ],
  });

  const handleShowCheckBoxErrors = (checkBoxGroup, errorKey, newValue, newKeyChange) => {
    let showError = true;
    if (newValue) {
      showError = false;
    } else {
      checkBoxGroup.forEach(({ code }) => {
        if (Boolean(data[code]) && code !== newKeyChange) {
          showError = false;
        }
      });
    }
    setShowCheckBoxError({
      ...showCheckBoxError,
      [errorKey]: showError,
    });
  };

  const handleGetisNotMatterPriorityId = useCallback(
    (data) => {
      if (data) {
        residencePriorities?.data?.data?.data.forEach(({ isNotMatter, id }) => {
          if (isNotMatter) {
            [
              "livingCityPriorityOneId",
              "livingCityPriorityTwoId",
              "livingCityPriorityThreeId",
            ].forEach((key) => {
              if (parseInt(data[key]) === id) {
                setEnabledPriority(key);
              }
            });
            setIsNotMatterPriorityId(id);
            return;
          }
        });
      }
    },
    [residencePriorities?.data]
  );

  const initializeEducationFieldToData = useCallback(() => {
    if (!data) return;
    let temp = { ...data };
    if (lookupsData?.data?.data[33000]) {
      lookupsData?.data?.data[33000].forEach((item) => {
        if (temp[item.code] === undefined) {
          temp[item.code] = false;
        }
      });
    }
    if (lookupsData?.data?.data[42000]) {
      lookupsData?.data?.data[42000].forEach((item) => {
        if (temp[item.code] === undefined) {
          temp[item.code] = false;
        }
      });
    }
  }, [data, lookupsData?.data?.data[42000], lookupsData?.data?.data[33000]]);

  useEffect(() => {
    handleGetisNotMatterPriorityId(data);
  }, [residencePriorities?.data?.data?.data]);

  useEffect(() => {
    if (isFetching === 0) {
      initializeEducationFieldToData();
    }
  }, [isFetching, initializeEducationFieldToData]);

  useEffect(() => {
    if (reloadPage) getDemandsInformation();
  }, [reloadPage]);

  useEffect(() => {
    const from = parseInt(data.fromYear);
    const to = parseInt(data.toYear);

    if (data?.fromYear?.toString()?.length == "4" && data?.toYear?.toString()?.length == "4") {
      if (from && to && from > to) {
        setErrors((prev) => ({
          ...prev,
          yearRange: "سال 'از' نباید بزرگتر از سال 'تا' باشد",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.yearRange;
          return newErrors;
        });
      }
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.yearRange;
        return newErrors;
      });
    }
  }, [data.fromYear, data.toYear]);

  return (
    <form style={{ width: "100%" }}>
      <Box display="flex" flexDirection="column" width="100%" alignItems="flex-end">
        <Typography variant="h1" mb="1rem">
          مشخصات ظاهری
        </Typography>
        <Grid
          container
          flexDirection="row-reverse"
          alignItems="center"
          sx={{ width: "100%", maxWidth: "100%" }}
        >
          <Grid
            item
            xs={6}
            sm={6}
            md={3}
            lg={3}
            xl={2}
            sx={{
              ...Style.itemGrid,
              paddingLeft: { xs: "1rem", sm: "1rem", md: "1rem", lg: "1rem" },
            }}
          >
            <Input
              label="از سال تولد"
              id="fromyear"
              name="fromyear"
              type="number"
              labelFlex={{ xs: 5, sm: 3, md: 4.9, lg: 4.7, xl: 4.65 }}
              flex={{ xs: 5, sm: 5, md: 2.1, lg: 2.1 }}
              disabled={disabled}
              value={data.fromYear}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "fromYear",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              onErrorMessage={(error_message) => {
                setErrors({ ...errors, ...error_message });
                onError({ ...errors, ...error_message });
              }}
              error={"fromYear" in pageErrors || !!errors.yearRange}
              placeholder="1400"
              validationType="year"
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={3}
            lg={3}
            xl={2.2}
            sx={{
              ...Style.itemGrid,
              paddingRight: { xs: "1rem", sm: "1rem", md: "1rem", lg: "1rem" },
            }}
          >
            <Input
              label="تا سال تولد"
              id="toYear"
              name="toYear"
              type="number"
              labelFlex={{ xs: 5, sm: 3, md: 5, lg: 5 }}
              flex={{ xs: 5, sm: 5, md: 2.3, lg: 2.3 }}
              disabled={disabled}
              value={data.toYear}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "toYear",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              onErrorMessage={(error_message) => {
                setErrors({ ...errors, ...error_message });
                onError({ ...errors, ...error_message });
              }}
              placeholder="1400"
              validationType="year"
              error={"toYear" in pageErrors || !!errors.yearRange}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={7}
            sx={{ ...Style.itemGrid, padding: "0 1.5rem" }}
          >
            <RangeSlider
              disabled={disabled}
              value={[data.fromHeight, data.toHeight]}
              onChange={(event, newValue) => {
                dispatch(
                  newValue[0] < 130
                    ? updateDemandsInformationData({
                        key: "fromHeight",
                        value: 130,
                        required: true,
                      })
                    : updateDemandsInformationData({
                        key: "fromHeight",
                        value: newValue[0],
                        required: true,
                      })
                );
                dispatch(
                  newValue[1] > 200
                    ? updateDemandsInformationData({
                        key: "toHeight",
                        value: 200,
                        required: true,
                      })
                    : updateDemandsInformationData({
                        key: "toHeight",
                        value: newValue[1],
                        required: true,
                      })
                );
              }}
            />
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Typography variant="h1" textAlign="right">
              وضعیت اعتقادی
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <AutoComplete
              label="وضعیت اعتقادی"
              id="beliefTypeCodes"
              name="beliefTypeCodes"
              idKey="code"
              labelKey="name"
              labelFlex={5}
              flex={7}
              disabled={disabled}
              data={lookupsData?.data?.data[28000] ?? []}
              value={lookupsData?.data?.data[28000].filter((option) =>
                data?.beliefTypeCodes?.includes(option.code)
              )}
              onChange={(event, e) => {
                dispatch(
                  updateDemandsInformationData({
                    key: "beliefTypeCodes",
                    value: event.map(({ code }) => code),
                    required: true,
                  })
                );
              }}
              error={"beliefTypeCodes" in pageErrors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <AutoComplete
              label=" گرایش سیاسی"
              id="politicalOrientationCodes"
              name="politicalOrientationCodes"
              labelKey="name"
              idKey="code"
              disabled={disabled}
              labelFlex={5}
              flex={7}
              data={lookupsData?.data?.data[5000] ?? []}
              value={lookupsData?.data?.data[5000].filter((option) =>
                data?.politicalOrientationCodes?.includes(option.code)
              )}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "politicalOrientationCodes",
                    value: event.map(({ code }) => code),
                    required: true,
                  })
                )
              }
              error={"politicalOrientationCodes" in pageErrors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <AutoComplete
              label="وضعیت پوشش"
              idKey="code"
              labelKey="name"
              id="clothingTypeCodes"
              name="clothingTypeCodes"
              labelFlex={5}
              flex={7}
              disabled={disabled}
              data={lookupsData?.data?.data[userInfo.genderTypeEnum !== 1 ? 37000 : 13000] ?? []}
              value={lookupsData?.data?.data[userInfo.genderTypeEnum !== 1 ? 37000 : 13000].filter(
                (option) => data?.clothingTypeCodes?.includes(option.code)
              )}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "clothingTypeCodes",
                    value: event.map(({ code }) => code),
                    required: true,
                  })
                )
              }
              error={"clothingTypeCodes" in pageErrors}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <BaseTextArea
              label="توضیحات"
              placeholder="در صورت نیاز توضیح دهید"
              id="religionDescription"
              name="religionDescription"
              flex={{ xs: 6.7, sm: 9.7, md: 9.65, lg: 9.65 }}
              labelFlex={{ xs: 5, sm: 2.5, md: 2.5, lg: 2.5 }}
              disabled={disabled}
              value={data.religionDescription}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "religionDescription",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"religionDescription" in pageErrors}
            />
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Box
            display="flex"
            alignItems={{ xs: "flex-end", sm: "center" }}
            flexDirection={{ xs: "column", sm: "row-reverse" }}
          >
            <Typography
              variant="h1"
              marginBottom="0.5rem"
              textAlign="right"
              marginLeft={{ xs: 0, sm: "1.5rem" }}
            >
              وضعیت تحصیلی
            </Typography>
            <Typography variant="h2" letterSpacing={0.5} textAlign="right" color="#9995b1">
              شما می‌توانید از بین گزینه‌ها، چند گزینه را انتخاب نمایید.
            </Typography>
          </Box>
          <Grid
            item
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-end"
            xs={12}
            sm={7}
            md={6}
            lg={6}
          >
            <Typography variant="h2" mt={3} mb={1}>
              سطح تحصیلات
            </Typography>
            {"educationLevelAllowedTitles" in pageErrors &&
              showCheckBoxError.educationLevelAllowedTitles && (
                <Typography
                  color="red"
                  fontSize="0.7rem"
                  sx={{
                    direction: "rtl",
                  }}
                >
                  ({pageErrors["educationLevelAllowedTitles"]})
                </Typography>
              )}
            {lookupsData?.data?.data[33000]?.map((educationLevel) => (
              <BaseCheckbox
                key={educationLevel.code}
                label={educationLevel.name}
                checked={Boolean(data[educationLevel.code])}
                disabled={disabled}
                value={educationLevel.code}
                onChange={(event) => {
                  handleShowCheckBoxErrors(
                    lookupsData?.data?.data[33000],
                    "educationLevelAllowedTitles",
                    event.target.checked,
                    educationLevel.code
                  );
                  dispatch(
                    updateDemandsInformationData({
                      key: educationLevel.code,
                      value: event.target.checked,
                      required: true,
                    })
                  );
                }}
                sx={{
                  padding: "0 0.74rem",
                  color: "#4C466F",
                  // fontSize: "14px",
                }}
                style={{
                  fontSize: "14px",
                }}
              />
            ))}
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-end"
            xs={12}
            sm={5}
            md={6}
            lg={6}
          >
            <Typography variant="h2" mt={3} mb={1}>
              شاخه تحصیلی
            </Typography>
            {"educationGroupAllowedTitles" in pageErrors &&
              showCheckBoxError.educationGroupAllowedTitles && (
                <Typography
                  color="red"
                  fontSize="0.7rem"
                  sx={{
                    direction: "rtl",
                  }}
                >
                  ({pageErrors["educationGroupAllowedTitles"]})
                </Typography>
              )}
            {lookupsData?.data?.data[42000]?.map((educationBranch) => (
              <BaseCheckbox
                key={educationBranch.code}
                label={educationBranch.name}
                checked={Boolean(data[educationBranch.code])}
                disabled={disabled}
                value={educationBranch.code}
                onChange={(event) => {
                  handleShowCheckBoxErrors(
                    lookupsData?.data?.data[42000],
                    "educationGroupAllowedTitles",
                    event.target.checked,
                    educationBranch.code
                  );
                  dispatch(
                    updateDemandsInformationData({
                      key: educationBranch.code,
                      value: event.target.checked,
                      required: true,
                    })
                  );
                }}
                sx={{
                  padding: "0 0.74rem",
                  color: "#4C466F",
                }}
              />
            ))}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid} marginTop="1.5rem">
            <BaseTextArea
              label="توضیحات"
              placeholder="در صورت نیاز توضیح دهید"
              id="educationDescription"
              name="educationDescription"
              disabled={disabled}
              flex={{ xs: 6.7, sm: 9.7, md: 9.65, lg: 9.65 }}
              labelFlex={{ xs: 5, sm: 2.5, md: 2.5, lg: 2.5 }}
              value={data.educationDescription}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "educationDescription",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"educationDescription" in pageErrors}
            />
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid
          container
          flexDirection="row-reverse"
          alignItems="center"
          sx={{ width: "100%", maxWidth: "800px" }}
        >
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Typography variant="h1" marginBottom="0.5rem" textAlign="right">
              وضعیت تاهل
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={8}>
            <Typography variant="h2" letterSpacing={0.5} textAlign="right" color="#9995b1">
              شما می‌توانید از بین گزینه‌ها، چند گزینه را انتخاب نمایید.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={8}>
            <Typography variant="h2" my={2}>
              وضعیت تاهل و فرزندان همسر
            </Typography>
            {"maritalStatus" in pageErrors && showCheckBoxError.maritalStatus && (
              <Typography
                color="red"
                fontSize="0.7rem"
                sx={{
                  direction: "rtl",
                }}
              >
                ({pageErrors["maritalStatus"]})
              </Typography>
            )}
          </Grid>
          {/* //todo : این قسمت از کد باید تمیز شود ولی الان زمانش رو نداشتم  */}
          <Grid
            item
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-end"
            xs={12}
            sm={7}
            md={6}
            lg={6}
            sx={{
              padding: "0 0.74rem",
            }}
          >
            <BaseCheckbox
              label="مجرد"
              checked={data.spouseSingle}
              disabled={disabled}
              value="spouseSingle"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "spouseSingle"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseSingle",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
            <BaseCheckbox
              label="عقد ناموفق (جدایی یا فوت)"
              checked={data.spouseUnsuccessfulContract}
              disabled={disabled}
              value="spouseUnsuccessfulContract"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "spouseUnsuccessfulContract"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseUnsuccessfulContract",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
            <BaseCheckbox
              label="جدا شده"
              checked={data.spouseDivorced}
              disabled={disabled}
              value="spouseDivorced"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "spouseDivorced"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseDivorced",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
            <BaseCheckbox
              label="همسر فوت شده"
              checked={data.spouseDeceased}
              disabled={disabled}
              value="spouseDeceased"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "spouseDeceased"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseDeceased",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
            <BaseCheckbox
              label="همسر شهید"
              checked={data.spouseMartyr}
              disabled={disabled}
              value="spouseMartyr"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "spouseMartyr"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseMartyr",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-end"
            xs={12}
            sm={7}
            md={6}
            lg={6}
            width={"100%"}
            sx={{
              padding: "0 0.74rem",
            }}
          >
            <BaseCheckbox
              label="فرزند/فرزندان همسر را می‌پذیرم"
              checked={data.haveChildrenAllowed}
              disabled={disabled}
              value="haveChildrenAllowed"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "haveChildrenAllowed"
                );
                handleHaveChildrenAllowed(event);
              }}
            />
            <BaseCheckbox
              label="جنسیت فرزند/فرزندان مهم است"
              checked={data.childGenderMatter}
              disabled={disabled || !data.haveChildrenAllowed}
              value="childGenderMatter"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "childGenderMatter"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "childGenderMatter",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
            <BaseCheckbox
              label="تعداد فرزند/فرزندان مهم است"
              checked={data.childrenCountMatter}
              disabled={disabled || !data.haveChildrenAllowed}
              value="childrenCountMatter"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "childrenCountMatter"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "childrenCountMatter",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
            <BaseCheckbox
              label="سن فرزند/فرزندان مهم است"
              checked={data.childrenAgeMatter}
              disabled={disabled || !data.haveChildrenAllowed}
              value="childrenAgeMatter"
              onChange={(event) => {
                handleShowCheckBoxErrors(
                  MARITAL_STATUS,
                  "maritalStatus",
                  event.target.checked,
                  "childrenAgeMatter"
                );
                dispatch(
                  updateDemandsInformationData({
                    key: "childrenAgeMatter",
                    value: event.target.checked,
                    required: true,
                  })
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <BaseTextArea
              label="توضیحات"
              placeholder="شرایط پذیرش فرزند/فرزندان همسر را توضیح دهید"
              id="marriageDescription"
              name="marriageDescription"
              disabled={disabled}
              flex={{ xs: 6.7, sm: 9.7, md: 9.6, lg: 9.6 }}
              labelFlex={{ xs: 5, sm: 2.5, md: 2.5, lg: 2.5 }}
              value={data.marriageDescription}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "marriageDescription",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
            />
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Typography variant="h1" my={1} textAlign="right">
              وضعیت سکونت
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Typography variant="h2" my={1} textAlign="right">
              استان‌هایی که بعداز ازدواج مایل به سکونت در آن‌ها هستید را مشخص نمایید.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} marginBottom="1rem">
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Select
                label="اولویت اول"
                idKey="id"
                labelKey="name"
                id="livingCityPriorityOneId"
                name="livingCityPriorityOneId"
                labelFlex={5}
                flex={7}
                disabled={
                  disabled ||
                  (enabledPriority !== "" && enabledPriority !== "livingCityPriorityOneId")
                }
                data={residencePriorities?.data?.data.data}
                value={data.livingCityPriorityOneId}
                onChange={(event) => handlelivingCityPriority("livingCityPriorityOneId", event)}
                error={"livingCityPriorityOneId" in pageErrors}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Select
                label="اولویت دوم"
                idKey="id"
                labelKey="name"
                id="livingCityPriorityTwoId"
                name="livingCityPriorityTwoId"
                labelFlex={5}
                flex={7}
                disabled={
                  disabled ||
                  (enabledPriority !== "" && enabledPriority !== "livingCityPriorityTwoId")
                }
                data={residencePriorities?.data?.data.data}
                value={data.livingCityPriorityTwoId}
                onChange={(event) => handlelivingCityPriority("livingCityPriorityTwoId", event)}
                error={"livingCityPriorityTwoId" in pageErrors}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Select
                label="اولویت سوم"
                idKey="id"
                labelKey="name"
                id="livingCityPriorityThreeId"
                name="livingCityPriorityThreeId"
                labelFlex={5}
                flex={7}
                disabled={
                  disabled ||
                  (enabledPriority !== "" && enabledPriority !== "livingCityPriorityThreeId")
                }
                data={residencePriorities?.data?.data.data}
                value={data.livingCityPriorityThreeId}
                onChange={(event) => handlelivingCityPriority("livingCityPriorityThreeId", event)}
                error={"livingCityPriorityThreeId" in pageErrors}
              />
            </Grid>
          </Grid>
          <BaseRadioGroup
            data={lookupsData?.data?.data[8000]}
            label="اقامت در خارج از کشور"
            value={data.residenceAbroadTypeCode !== undefined ? data.residenceAbroadTypeCode : ""}
            onChange={(event) =>
              dispatch(
                updateDemandsInformationData({
                  key: "residenceAbroadTypeCode",
                  value: event.target.value,
                  required: true,
                })
              )
            }
            labelGridSize={{
              display: "flex",
              alignItems: "center",
              flexDirection: { xs: "column-reverse", sm: "row" },
            }}
            error={pageErrors["residenceAbroadTypeCode"]}
          />
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Typography variant="h1" my={1} textAlign="right">
                سایر خواسته‌ها
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              flexDirection={{
                xs: "column",
                sm: "row-reverse",
                md: "row-reverse",
                lg: "row-reverse",
              }}
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                xs={12}
                sm={6}
                md={6}
                lg={6}
                sx={Style.itemGrid}
              >
                <AutoComplete
                  id="spouseEconomicMatterCodes"
                  name="spouseEconomicMatterCodes"
                  label="وضعیت اقتصادی همسر"
                  idKey="code"
                  labelKey="name"
                  flex={7}
                  labelFlex={5}
                  disabled={disabled}
                  data={lookupsData?.data?.data[11000] ?? []}
                  value={lookupsData?.data?.data[11000].filter((option) =>
                    data?.spouseEconomicMatterCodes?.includes(option.code)
                  )}
                  onChange={(event) =>
                    dispatch(
                      updateDemandsInformationData({
                        key: "spouseEconomicMatterCodes",
                        value: event.map(({ code }) => code),
                        required: true,
                      })
                    )
                  }
                  error={"spouseEconomicMatterCodes" in pageErrors}
                />
              </Grid>
            </Grid>
            <Grid
              item
              display="flex"
              flexDirection={{
                xs: "column",
                sm: "row-reverse",
                md: "row-reverse",
                lg: "row-reverse",
              }}
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Grid
                item
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                xs={12}
                sm={6}
                md={6}
                lg={6}
                sx={Style.itemGrid}
              >
                <AutoComplete
                  id="spouseWorkingMatterCodes"
                  name="spouseWorkingMatterCodes"
                  disabled={disabled}
                  idKey="code"
                  labelKey="name"
                  label="وضعیت شغلی همسر"
                  flex={7}
                  labelFlex={5}
                  data={lookupsData?.data?.data[25000] ?? []}
                  value={lookupsData?.data?.data[25000].filter((option) =>
                    data?.spouseWorkingMatterCodes?.includes(option.code)
                  )}
                  onChange={(event) =>
                    dispatch(
                      updateDemandsInformationData({
                        key: "spouseWorkingMatterCodes",
                        value: event.map(({ code }) => code),
                        required: true,
                      })
                    )
                  }
                  error={"spouseWorkingMatterCodes" in pageErrors}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h2" mt={2} mb={1} textAlign="right">
                آیا قومیت همسر مهم است؟
              </Typography>
              {"spouseEthnicityMatter" in pageErrors &&
                data.spouseEthnicityCodes.length === 0 &&
                isSpouseEthnicity && (
                  <Typography
                    color="red"
                    fontSize="0.7rem"
                    sx={{
                      direction: "rtl",
                    }}
                  >
                    ({pageErrors["spouseEthnicityMatter"]})
                  </Typography>
                )}
            </Grid>
            <Grid
              item
              display="flex"
              justifyContent="flex-start"
              flexDirection={{
                xs: "column",
                sm: "row-reverse",
                md: "row-reverse",
                lg: "row-reverse",
              }}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={Style.itemGrid}
            >
              <Grid
                item
                display="flex"
                justifyContent="flex-end"
                xs={12}
                sm={6}
                md={5}
                lg={4}
                sx={Style.itemGrid}
              >
                <RadioGroup
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row-reverse" },
                    alignItems: { xs: "flex-end", sm: "center", md: "center" },
                    width: { xs: "100%" },
                  }}
                  value={data.spouseEthnicityMatter}
                  onChange={(event) => {
                    dispatch(
                      updateDemandsInformationData({
                        key: "spouseEthnicityMatter",
                        value: event.target.value,
                        required: true,
                      })
                    );

                    setIsSpouseEthnicity(event.target.value === "true");
                    if (event.target.value === "false")
                      dispatch(
                        updateDemandsInformationData({
                          key: "spouseEthnicityCode",
                          value: undefined,
                          required: true,
                        })
                      );
                    dispatch(
                      updateArrayFieldDemandsInformationData({
                        key: "spouseEthnicityCodes",
                        value: event.target.checked,
                        required: true,
                        code: "",
                        reset: true,
                      })
                    );
                  }}
                >
                  <BaseRadio text="بله" value={true} disabled={disabled} />
                  <BaseRadio
                    text="خیر"
                    value={false}
                    disabled={disabled}
                    containerStyle={{
                      margin: { sm: "0 1.7rem 0 0" },
                    }}
                  />
                </RadioGroup>
              </Grid>
            </Grid>

            {isSpouseEthnicity && (
              <Grid
                container
                display="flex"
                flexDirection="column"
                alignContent="flex-start"
                flexWrap={{ xs: "nowrap", sm: "wrap", lg: "wrap", xl: "wrap" }}
                height={{ sm: 200, lg: 200, xl: 200 }}
                sx={{ direction: "rtl" }}
                mb={3}
              >
                {lookupsData?.data?.data[26000]?.map(({ code, name }) => (
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    lg={3}
                    width={{ xs: "100%", sm: "100%", lg: "33%", xl: "33%" }}
                    key={code}
                    display="flex"
                    flexDirection="flex-start"
                    justifyContent="flex-end"
                    alignItems="flex-start"
                    sx={{ direction: "ltr" }}
                  >
                    <BaseCheckbox
                      label={name}
                      id={code}
                      name={code}
                      checked={
                        data.spouseEthnicityCodes
                          ? data?.spouseEthnicityCodes.includes(`${code}`)
                          : false
                      }
                      disabled={disabled}
                      value={name}
                      onChange={(event) => {
                        dispatch(
                          updateArrayFieldDemandsInformationData({
                            key: "spouseEthnicityCodes",
                            value: event.target.checked,
                            required: true,
                            code: code,
                            reset: false,
                          })
                        );
                      }}
                      sx={{
                        paddingRight: "1.22rem",
                        // color: "#4C466F",
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
              <Typography variant="h2" marginTop="1rem" textAlign="right">
                اگر خانواده همسر در استان/شهر دیگری زندگی کنند می‌پذیرید؟
              </Typography>
            </Grid>
            <Grid
              item
              display="flex"
              justifyContent="flex-end"
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={Style.itemGrid}
            >
              <RadioGroup
                value={data.spouseFamilyInOtherCityAllowed}
                onChange={(event) =>
                  dispatch(
                    updateDemandsInformationData({
                      key: "spouseFamilyInOtherCityAllowed",
                      value: event.target.value,
                      required: true,
                    })
                  )
                }
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row-reverse" },
                  alignItems: { xs: "flex-end", sm: "center", md: "center" },
                  width: "100%",
                }}
              >
                <BaseRadio text="بله" value={true} disabled={disabled} />
                <BaseRadio
                  text="خیر"
                  value={false}
                  disabled={disabled}
                  containerStyle={{
                    margin: { sm: "0 1.7rem 0 0" },
                  }}
                />
              </RadioGroup>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h2" my={2} textAlign="right">
              آیا شغل نظامی همسر را می‌پذیرید؟
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={Style.itemGrid}
          >
            <RadioGroup
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row-reverse" },
                alignItems: { xs: "flex-end", sm: "center", md: "center" },
                direction: "ltr",
              }}
              value={data.spouseMilitaryAllowed}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseMilitaryAllowed",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
            >
              <BaseRadio text="بله" value={true} disabled={disabled} />
              <BaseRadio
                text="خیر"
                value={false}
                disabled={disabled}
                containerStyle={{
                  margin: { sm: "0 1.7rem 0 0" },
                }}
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h2" my={2} textAlign="right">
              آیا روحانی/طلبه ملبس را می‌پذیرید؟
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={Style.itemGrid}
          >
            <RadioGroup
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row-reverse" },
                alignItems: { xs: "flex-end", sm: "center", md: "center" },
                width: "100%",
              }}
              value={data.spouseSpiritualAllowed}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseSpiritualAllowed",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
            >
              <BaseRadio text="بله" value={true} disabled={disabled} />
              <BaseRadio
                text="خیر"
                value={false}
                disabled={disabled}
                containerStyle={{
                  margin: { sm: "0 1.7rem 0 0" },
                }}
              />
            </RadioGroup>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h2" my={2} textAlign="right">
              آیا قومیت همسر مهم است؟
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-start"
            flexDirection={{
              xs: "column",
              sm: "row-reverse",
              md: "row-reverse",
              lg: "row-reverse",
            }}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={Style.itemGrid}
          >
            <Grid
              item
              display="flex"
              justifyContent="flex-end"
              xs={12}
              sm={6}
              md={5}
              lg={4}
              sx={Style.itemGrid}
            >
              <RadioGroup
                sx={{
                  display: "flex",
                  flexDirection: {
                    xs: "column-reverse",
                    sm: "row-reverse",
                    md: "row-reverse",
                    lg: "row-reverse",
                  },
                  alignItems: { xs: "end", sm: "center", md: "center" },
                  width: { xs: "100%" },
                }}
                value={data.spouseEthnicityMatter}
                onChange={(event) => {
                  dispatch(
                    updateDemandsInformationData({
                      key: "spouseEthnicityMatter",
                      value: event.target.value,
                      required: true,
                    })
                  );

                  setIsSpouseEthnicity(event.target.value === "true");
                  if (event.target.value === "false")
                    dispatch(
                      updateDemandsInformationData({
                        key: "spouseEthnicityCode",
                        value: undefined,
                        required: true,
                      })
                    );
                  dispatch(
                    updateArrayFieldDemandsInformationData({
                      key: "spouseEthnicityCodes",
                      value: event.target.checked,
                      required: true,
                      code: "",
                      reset: true,
                    })
                  );
                }}
              >
                <BaseRadio text="بله" value={true} disabled={disabled} />
                <BaseRadio text="خیر" value={false} disabled={disabled} />
              </RadioGroup>
            </Grid>
          </Grid>
          {isSpouseEthnicity && (
            <Grid
              container
              display="flex"
              flexDirection="column"
              alignContent="flex-start"
              flexWrap={{ xs: "nowrap", sm: "wrap", lg: "wrap", xl: "wrap" }}
              height={{ sm: 200, lg: 200, xl: 200 }}
              sx={{ direction: "rtl" }}
              mb={3}
            >
              {spouseEthnicity.map(({ code, name }) => (
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={3}
                  lg={3}
                  width={{ xs: "100%", sm: "100%", lg: "33%", xl: "33%" }}
                  key={code}
                  display="flex"
                  flexDirection="flex-start"
                  justifyContent="flex-end"
                  alignItems="flex-start"
                  sx={{ direction: "ltr" }}
                >
                  <BaseCheckbox
                    label={name}
                    id={code}
                    name={code}
                    checked={
                      data.spouseEthnicityCodes
                        ? data?.spouseEthnicityCodes.includes(`${code}`)
                        : false
                    }
                    disabled={disabled}
                    value={name}
                    onChange={(event) => {
                      dispatch(
                        updateArrayFieldDemandsInformationData({
                          key: "spouseEthnicityCodes",
                          value: event.target.checked,
                          required: true,
                          code: code,
                          reset: false,
                        })
                      );
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )} */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h2" my={2} textAlign="right">
              چه نوع شخصیتی را برای همسر می‌پذیرید؟
            </Typography>
          </Grid>
          <Grid item display="flex" justifyContent="flex-end" xs={12} sm={12} md={12} lg={12}>
            <RadioGroup
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "row-reverse",
                  md: "row-reverse",
                },
                alignItems: { xs: "flex-end", sm: "center", md: "center" },
              }}
              value={data.spousePersonalityCode}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "spousePersonalityCode",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
            >
              {lookupsData?.data?.data[27000]?.map((item, index) => (
                <BaseRadio text={item.name} value={item.code} disabled={disabled} key={index} />
              ))}
            </RadioGroup>
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        {/* <Box my={3} width="100%">
          <Divider />
        </Box> */}
        {/* //! in qsmt nabayad pak beshe ta taklifesh moshakhas beshe */}
        {/* <Box my={3} width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Typography variant="h1" marginBottom="0.5rem" textAlign="right">
              اطلاعات جانبی
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={8} marginBottom="1rem">
            <Typography variant="h2" letterSpacing={0.5} textAlign="right" color="#9995b1">
              شما می‌توانید از بین گزینه‌ها، چند گزینه را انتخاب کنید
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <BaseCheckbox
              label="همسرم مصرف کننده سیگار نباشد"
              checked={data.spouseNotSmoker}
              disabled={disabled}
              value="spouseNotSmoker"
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseNotSmoker",
                    value: event.target.checked,
                    required: true,
                  })
                )
              }
            />
            <BaseCheckbox
              label="با استعمال قلیان مشکلی ندارم"
              checked={data.hookahAllowed}
              disabled={disabled}
              value="hookahAllowed"
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "hookahAllowed",
                    value: event.target.checked,
                    required: true,
                  })
                )
              }
            />
            <BaseCheckbox
              label="تمایل دارم همسرم ورزشکار باشد"
              checked={data.spouseMustBeAthlete}
              disabled={disabled}
              value="spouseMustBeAthlete"
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseMustBeAthlete",
                    value: event.target.checked,
                    required: true,
                  })
                )
              }
            />
            <BaseCheckbox
              label="تمایل دارم همسرم اهل هنر باشد"
              checked={data.spouseMustBeArtist}
              disabled={disabled}
              value="spouseMustBeArtist"
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "spouseMustBeArtist",
                    value: event.target.checked,
                    required: true,
                  })
                )
              }
            />
          </Grid>
        </Grid> */}
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid item display="flex" justifyContent="flex-end" xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h2" textAlign="right">
              می خواهم مرکز با شخص دیگری برای هماهنگی ها تماس بگیرد. ( به عنوان مثال : مادر یا اعضای
              خانواده، فامیل )
            </Typography>
            <BaseSwitch
              checked={!data.isContactMe}
              disabled={disabled}
              onChange={(event) => {
                dispatch(
                  updateDemandsInformationData({
                    key: "isContactMe",
                    value: !event.target.checked,
                    required: true,
                  })
                );
                handleIsContactMe(event);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Typography variant="h1" my={2} textAlign="right">
              اطلاعات تماس معتمد
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <Input
              label="نام"
              placeholder="نام"
              id="trustedFirstName"
              name="trustedFirstName"
              labelFlex={4.95}
              flex={7}
              disabled={data.isContactMe || disabled}
              value={data.trustedFirstName}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "trustedFirstName",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"trustedFirstName" in pageErrors}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <Input
              placeholder=" نام خانوادگی"
              label="نام خانوادگی"
              id="trustedLastName"
              name="trustedLastName"
              labelFlex={5}
              flex={7}
              disabled={data.isContactMe || disabled}
              value={data.trustedLastName}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "trustedLastName",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"trustedLastName" in pageErrors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <Input
              label="نسبت"
              placeholder="نسبت"
              id="trustedRelation1"
              name="trustedRelation1"
              labelFlex={4.95}
              flex={7}
              disabled={data.isContactMe || disabled}
              value={data.trustedRelation1}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "trustedRelation1",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"trustedRelation1" in pageErrors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <Input
              label="تلفن ثابت (‌اختیاری) "
              placeholder="تلفن ثابت (‌اختیاری) "
              id="trustedLandNumber"
              name="trustedLandNumber"
              labelFlex={5}
              flex={7}
              type="number"
              disabled={data.isContactMe || disabled}
              value={data.trustedLandNumber}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "trustedLandNumber",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"trustedLandNumber" in pageErrors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} sx={Style.itemGrid}>
            <Input
              label="تلفن همراه"
              placeholder="تلفن همراه"
              id="trustedMobileNumber"
              name="trustedMobileNumber"
              labelFlex={4.95}
              flex={7}
              type="number"
              disabled={data.isContactMe || disabled}
              value={data.trustedMobileNumber}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "trustedMobileNumber",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              onErrorMessage={(error_message) => {
                setErrors({ ...errors, ...error_message });
                onError({ ...errors, ...error_message });
              }}
              validationType="phoneNumber"
              error={"trustedMobileNumber" in pageErrors}
            />
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Typography variant="h1" textAlign="right">
              زمان مصاحبه
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <Typography variant="h2" textAlign="right">
              لطفا زمان هایی که در طول هفته جهت حضور در جلسه مصاحبه برای شما مناسب است را بنویسید.
            </Typography>
            <Typography variant="h2" textAlign="right">
              (بجز پنجشنبه ، جمعه، تعطیلات رسمی)
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
            <BaseTextArea
              label=""
              placeholder="در صورت نیاز توضیح دهید"
              id="firstInterviewDescription"
              name="firstInterviewDescription"
              flex={{ xs: 6.7, sm: 9.7, md: 9.7, lg: 9.7 }}
              labelFlex={{ xs: 5, sm: 2.5, md: 2.5, lg: 2.5 }}
              disabled={disabled}
              value={data.firstInterviewDescription}
              onChange={(event) =>
                dispatch(
                  updateDemandsInformationData({
                    key: "firstInterviewDescription",
                    value: event.target.value,
                    required: true,
                  })
                )
              }
              error={"firstInterviewDescription" in pageErrors}
            />
          </Grid>
        </Grid>
        <Box mt="1.3rem" mb="2rem" width="100%">
          <Divider />
        </Box>
        <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h1" my={2} textAlign="right">
              سایر ملاک‌های خود را براساس اولویت اضافه نمایید
            </Typography>
          </Grid>
          {disabled && data.otherDemands.length === 0 && (
            <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "800px" }}>
              <Typography variant="h2" textAlign="right">
                در این بخش ملاکی ثبت نشده است.
              </Typography>
            </Grid>
          )}
          {(!disabled || data.otherDemands.length !== 0) &&
            data.otherDemands.map((item, index) => (
              <Grid
                key={index}
                marginBottom="0.7rem"
                display="flex"
                flexDirection="row-reverse"
                item
                xs={12}
                sm={12}
                md={12}
                lg={11.76}
              >
                <Box flex={1}>
                  <BaseTextArea
                    label={`اولویت ${index + 1}`}
                    placeholder="اولويت خود را توضيح دهيد"
                    id={`order_${index}`}
                    name={`order_${index}`}
                    labelFlex={{ xs: 1, sm: 2, md: 2, lg: 2.7, xl: 2.7 }}
                    flex={{ xs: 4, sm: 6, md: 8, lg: 9.3, xl: 9.21 }}
                    disabled={disabled}
                    value={item}
                    onChange={(event) =>
                      dispatch(updateOtherDemand({ index, value: event.target.value }))
                    }
                  />
                </Box>
                <IconButton
                  sx={{
                    backgroundColor: "#EAEAEA",
                    borderRadius: "0.6rem",
                    marginRight: "1.5rem",
                  }}
                  disabled={disabled}
                  onClick={() => dispatch(removeFromOtherDemand(index))}
                >
                  <HiOutlineTrash />
                </IconButton>
              </Grid>
            ))}
          {!disabled && (
            <Grid item xs={12} sx={Style.itemGrid}>
              <AddField
                handleAdd={() => dispatch(addNewOtherDemand())}
                title="اضافه کردن ملاک انتخاب همسر"
              />
            </Grid>
          )}
        </Grid>
        <Box
          width="100%"
          sx={{
            display: "flex",
            flexDirection: { xs: "row", sm: "row", md: "row" },
            justifyContent: "center",
            alignItems: "center",
            pt: 2,
            mt: "2rem",
          }}
        >
          <Button
            name="next"
            type="button"
            variant="m1"
            onClick={() => {
              handleSubmitForm("/personal-info/document");
            }}
            sx={{ mr: 1, width: "165px", my: { xs: 1, sm: 0, md: 0 } }}
          >
            بعدی
          </Button>
          <Button
            type="button"
            onClick={() => {
              handleSubmitForm("/personal-info/family-info");
            }}
            name="previous"
            variant="m2"
            sx={{ mr: 1 }}
          >
            قبلی
          </Button>
        </Box>
      </Box>
    </form>
  );
}

const Style = {
  itemGrid: {
    boxSizing: "border-box",
    paddingLeft: { xs: 0, sm: "0.5rem", md: "1rem", lg: "1rem" },
    marginBottom: "0.75rem",
  },
};

const MARITAL_STATUS = [
  { code: "spouseSingle" },
  { code: "spouseUnsuccessfulContract" },
  { code: "spouseDivorced" },
  { code: "spouseDeceased" },
  { code: "spouseMartyr" },
  { code: "haveChildrenAllowed" },
  { code: "childGenderMatter" },
  { code: "childrenCountMatter" },
  { code: "childrenAgeMatter" },
];

export default Requests;
